import { Card } from "@mui/material";
import type { ReactNode } from "react";
import { overviewCardStyle } from "../../misc/backofficeTheme";

export function VehicleDataCard(props: { children: ReactNode }) {
  const { children } = props;

  return (
    <Card
      sx={{
        ...overviewCardStyle,
        minWidth: 0,
        padding: { xs: "16px", sm: overviewCardStyle.padding },
      }}
    >
      {children}
    </Card>
  );
}
